/**
 * Dummy data — 회원 관리 (관리자)
 * API_DOCS: 26. 관리자 - 회원
 *
 * UserAdminResponse:
 *   id(int), email(string?), name(string?), phone(string?), role(string),
 *   social_provider(string?), is_active(boolean), created_at(datetime)
 *
 * 상태 변경: PUT /api/admin/users/{user_id}/status → { status: "active"|"inactive" }
 */

const members = [
  { id: 1, email: 'minsu@gmail.com', name: '김민수', phone: '010-1234-5678', role: 'user', social_provider: null, is_active: true, created_at: '2026-01-01T10:00:00' },
  { id: 2, email: 'jieun@gmail.com', name: '이지은', phone: '010-2345-6789', role: 'user', social_provider: 'kakao', is_active: true, created_at: '2026-01-05T14:30:00' },
  { id: 3, email: 'sjpark@gmail.com', name: '박서준', phone: '010-3456-7890', role: 'user', social_provider: null, is_active: true, created_at: '2026-01-10T09:00:00' },
  { id: 4, email: 'yuna@gmail.com', name: '최유나', phone: '010-4567-8901', role: 'user', social_provider: 'naver', is_active: true, created_at: '2026-01-12T11:20:00' },
  { id: 5, email: 'john@gmail.com', name: 'John Smith', phone: '010-5678-9012', role: 'user', social_provider: 'google', is_active: false, created_at: '2026-01-15T16:00:00' },
  { id: 6, email: 'admin@vipvantour.com', name: '관리자', phone: '010-0000-0000', role: 'admin', social_provider: null, is_active: true, created_at: '2025-12-01T00:00:00' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/admin/users — 회원 목록 (query: role, search, page, size) */
export const getMembers = async (params = {}) => {
  await delay(300);
  let filtered = [...members];

  if (params.role) filtered = filtered.filter((m) => m.role === params.role);
  if (params.search) {
    const q = params.search.toLowerCase();
    filtered = filtered.filter((m) =>
      (m.name && m.name.toLowerCase().includes(q)) ||
      (m.email && m.email.toLowerCase().includes(q)) ||
      (m.phone && m.phone.includes(q))
    );
  }

  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;

  return {
    items: filtered.slice(start, start + size),
    total: filtered.length,
    page,
    size,
    pages: Math.ceil(filtered.length / size),
  };
};

/** GET /api/admin/users/:id — 회원 상세 */
export const getMemberById = async (id) => {
  await delay(200);
  const found = members.find((m) => m.id === Number(id));
  if (!found) throw new Error('회원을 찾을 수 없습니다');
  return found;
};

/** PUT /api/admin/users/:id/status — 상태 변경 */
export const updateMemberStatus = async (id, status) => {
  await delay(400);
  const found = members.find((m) => m.id === Number(id));
  if (!found) throw new Error('회원을 찾을 수 없습니다');
  found.is_active = status === 'active';
  return { message: '상태가 변경되었습니다' };
};

/** DELETE /api/admin/users/:id — 회원 삭제 (비활성화) */
export const deleteMember = async (id) => {
  await delay(400);
  const found = members.find((m) => m.id === Number(id));
  if (!found) throw new Error('회원을 찾을 수 없습니다');
  found.is_active = false;
  return { message: '회원이 삭제되었습니다' };
};

/** GET /api/admin/users/:id/reservations — 회원 예약 내역 */
export const getMemberReservations = async (id, params = {}) => {
  await delay(200);
  return [];
};

/** GET /api/admin/users/:id/reviews — 회원 리뷰 내역 */
export const getMemberReviews = async (id, params = {}) => {
  await delay(200);
  return [];
};
